module.exports = __webpack_public_path__ + "img/stahltreppe.78c1e2fa.jpg";